import { Route } from './parts/route';
import { Router } from './parts/use-router';

import atendimento_cliente_page_page_tsxPage from '../pages/atendimento-cliente-page/page';
import { setRoutePermissions as atendimento_cliente_page_page_tsxSetPerm } from '../pages/atendimento-cliente-page/page';
import atendimentos_page_tsxPage from '../pages/atendimentos/page';
import { setRoutePermissions as atendimentos_page_tsxSetPerm } from '../pages/atendimentos/page';
import campanha_sms_page_tsxPage from '../pages/campanha-sms/page';
import { setRoutePermissions as campanha_sms_page_tsxSetPerm } from '../pages/campanha-sms/page';
import campanha_ura_whatsapp_page_tsxPage from '../pages/campanha-ura-whatsapp/page';
import { setRoutePermissions as campanha_ura_whatsapp_page_tsxSetPerm } from '../pages/campanha-ura-whatsapp/page';
import campanha_whatsapp_page_tsxPage from '../pages/campanha-whatsapp/page';
import carteira_page_tsxPage from '../pages/carteira/page';
import { setRoutePermissions as carteira_page_tsxSetPerm } from '../pages/carteira/page';
import config_atendimento_index_tsxPage from '../pages/config-atendimento/index';
import { setRoutePermissions as config_atendimento_index_tsxSetPerm } from '../pages/config-atendimento/index';
import configuracoes_modelos_pipeline_page_tsxPage from '../pages/configuracoes/modelos-pipeline/page';
import { setRoutePermissions as configuracoes_modelos_pipeline_page_tsxSetPerm } from '../pages/configuracoes/modelos-pipeline/page';
import confirm_licenses_page_tsxPage from '../pages/confirm-licenses/page';
import { setRoutePermissions as confirm_licenses_page_tsxSetPerm } from '../pages/confirm-licenses/page';
import consulta_page_tsxPage from '../pages/consulta/page';
import { setRoutePermissions as consulta_page_tsxSetPerm } from '../pages/consulta/page';
import consulta_extrato_online_page_tsxPage from '../pages/consulta-extrato-online/page';
import { setRoutePermissions as consulta_extrato_online_page_tsxSetPerm } from '../pages/consulta-extrato-online/page';
import consulta_hot_page_tsxPage from '../pages/consulta-hot/page';
import { setRoutePermissions as consulta_hot_page_tsxSetPerm } from '../pages/consulta-hot/page';
import consulta_telefonia_page_tsxPage from '../pages/consulta-telefonia/page';
import { setRoutePermissions as consulta_telefonia_page_tsxSetPerm } from '../pages/consulta-telefonia/page';
import docs_api_gateway_page_tsxPage from '../pages/docs-api-gateway/page';
import { setRoutePermissions as docs_api_gateway_page_tsxSetPerm } from '../pages/docs-api-gateway/page';
import empresas_page_tsxPage from '../pages/empresas/page';
import { setRoutePermissions as empresas_page_tsxSetPerm } from '../pages/empresas/page';
import equipes_de_venda_page_tsxPage from '../pages/equipes-de-venda/page';
import { setRoutePermissions as equipes_de_venda_page_tsxSetPerm } from '../pages/equipes-de-venda/page';
import extrato_online_lote_page_tsxPage from '../pages/extrato-online-lote/page';
import { setRoutePermissions as extrato_online_lote_page_tsxSetPerm } from '../pages/extrato-online-lote/page';
import higienizacao_api_cartao_banco_page_tsxPage from '../pages/higienizacao-api-cartao-banco/page';
import { setRoutePermissions as higienizacao_api_cartao_banco_page_tsxSetPerm } from '../pages/higienizacao-api-cartao-banco/page';
import higienizacao_refin_page_tsxPage from '../pages/higienizacao-refin/page';
import { setRoutePermissions as higienizacao_refin_page_tsxSetPerm } from '../pages/higienizacao-refin/page';
import in100_page_tsxPage from '../pages/in100/page';
import { setRoutePermissions as in100_page_tsxSetPerm } from '../pages/in100/page';
import informar_contato_page_tsxPage from '../pages/informar-contato/page';
import login_page_tsxPage from '../pages/login/page';
import mailing_page_tsxPage from '../pages/mailing/page';
import { setRoutePermissions as mailing_page_tsxSetPerm } from '../pages/mailing/page';
import mailing_pipeline__id__tsxPage from '../pages/mailing/pipeline/[id]';
import { setRoutePermissions as mailing_pipeline__id__tsxSetPerm } from '../pages/mailing/pipeline/[id]';
import mailing_pipelines_list_index_tsxPage from '../pages/mailing/pipelines-list/index';
import { setRoutePermissions as mailing_pipelines_list_index_tsxSetPerm } from '../pages/mailing/pipelines-list/index';
import margem_convenio_service_page_tsxPage from '../pages/margem-convenio-service/page';
import { setRoutePermissions as margem_convenio_service_page_tsxSetPerm } from '../pages/margem-convenio-service/page';
import mudancas_update_page_tsxPage from '../pages/mudancas-update/page';
import { setRoutePermissions as mudancas_update_page_tsxSetPerm } from '../pages/mudancas-update/page';
import not_found_page_tsxPage from '../pages/not-found/page';
import page_tsxPage from '../pages/page';
import { setRoutePermissions as page_tsxSetPerm } from '../pages/page';
import prospeccao_parceiros_page_tsxPage from '../pages/prospeccao-parceiros/page';
import { setRoutePermissions as prospeccao_parceiros_page_tsxSetPerm } from '../pages/prospeccao-parceiros/page';
import servicos_page_tsxPage from '../pages/servicos/page';
import { setRoutePermissions as servicos_page_tsxSetPerm } from '../pages/servicos/page';
import sessoes_whatsapp_page_tsxPage from '../pages/sessoes-whatsapp/page';
import { setRoutePermissions as sessoes_whatsapp_page_tsxSetPerm } from '../pages/sessoes-whatsapp/page';
import tabelas_page_tsxPage from '../pages/tabelas/page';
import { setRoutePermissions as tabelas_page_tsxSetPerm } from '../pages/tabelas/page';
import usuario_bloqueado_index_tsxPage from '../pages/usuario-bloqueado/index';
import { setRoutePermissions as usuario_bloqueado_index_tsxSetPerm } from '../pages/usuario-bloqueado/index';
import usuarios_page_tsxPage from '../pages/usuarios/page';
import { setRoutePermissions as usuarios_page_tsxSetPerm } from '../pages/usuarios/page';
import usuarios_bancos_page_tsxPage from '../pages/usuarios-bancos/page';
import { setRoutePermissions as usuarios_bancos_page_tsxSetPerm } from '../pages/usuarios-bancos/page';
import vende_ai_page_tsxPage from '../pages/vende-ai/page';
import { setRoutePermissions as vende_ai_page_tsxSetPerm } from '../pages/vende-ai/page';
import whatsapp_service_page_tsxPage from '../pages/whatsapp-service/page';
import { setRoutePermissions as whatsapp_service_page_tsxSetPerm } from '../pages/whatsapp-service/page';

const route0 = new Route("/atendimento-cliente-page", atendimento_cliente_page_page_tsxPage);
atendimento_cliente_page_page_tsxSetPerm(route0);
Router.addRoute(route0);

const route1 = new Route("/atendimentos", atendimentos_page_tsxPage);
atendimentos_page_tsxSetPerm(route1);
Router.addRoute(route1);

const route2 = new Route("/campanha-sms", campanha_sms_page_tsxPage);
campanha_sms_page_tsxSetPerm(route2);
Router.addRoute(route2);

const route3 = new Route("/campanha-ura-whatsapp", campanha_ura_whatsapp_page_tsxPage);
campanha_ura_whatsapp_page_tsxSetPerm(route3);
Router.addRoute(route3);

const route4 = new Route("/campanha-whatsapp", campanha_whatsapp_page_tsxPage);
Router.addRoute(route4);

const route5 = new Route("/carteira", carteira_page_tsxPage);
carteira_page_tsxSetPerm(route5);
Router.addRoute(route5);

const route6 = new Route("/config-atendimento", config_atendimento_index_tsxPage);
config_atendimento_index_tsxSetPerm(route6);
Router.addRoute(route6);

const route7 = new Route("/configuracoes/modelos-pipeline", configuracoes_modelos_pipeline_page_tsxPage);
configuracoes_modelos_pipeline_page_tsxSetPerm(route7);
Router.addRoute(route7);

const route8 = new Route("/confirm-licenses", confirm_licenses_page_tsxPage);
confirm_licenses_page_tsxSetPerm(route8);
Router.addRoute(route8);

const route9 = new Route("/consulta", consulta_page_tsxPage);
consulta_page_tsxSetPerm(route9);
Router.addRoute(route9);

const route10 = new Route("/consulta-extrato-online", consulta_extrato_online_page_tsxPage);
consulta_extrato_online_page_tsxSetPerm(route10);
Router.addRoute(route10);

const route11 = new Route("/consulta-hot", consulta_hot_page_tsxPage);
consulta_hot_page_tsxSetPerm(route11);
Router.addRoute(route11);

const route12 = new Route("/consulta-telefonia", consulta_telefonia_page_tsxPage);
consulta_telefonia_page_tsxSetPerm(route12);
Router.addRoute(route12);

const route13 = new Route("/docs-api-gateway", docs_api_gateway_page_tsxPage);
docs_api_gateway_page_tsxSetPerm(route13);
Router.addRoute(route13);

const route14 = new Route("/empresas", empresas_page_tsxPage);
empresas_page_tsxSetPerm(route14);
Router.addRoute(route14);

const route15 = new Route("/equipes-de-venda", equipes_de_venda_page_tsxPage);
equipes_de_venda_page_tsxSetPerm(route15);
Router.addRoute(route15);

const route16 = new Route("/extrato-online-lote", extrato_online_lote_page_tsxPage);
extrato_online_lote_page_tsxSetPerm(route16);
Router.addRoute(route16);

const route17 = new Route("/higienizacao-api-cartao-banco", higienizacao_api_cartao_banco_page_tsxPage);
higienizacao_api_cartao_banco_page_tsxSetPerm(route17);
Router.addRoute(route17);

const route18 = new Route("/higienizacao-refin", higienizacao_refin_page_tsxPage);
higienizacao_refin_page_tsxSetPerm(route18);
Router.addRoute(route18);

const route19 = new Route("/in100", in100_page_tsxPage);
in100_page_tsxSetPerm(route19);
Router.addRoute(route19);

const route20 = new Route("/informar-contato", informar_contato_page_tsxPage);
Router.addRoute(route20);

const route21 = new Route("/login", login_page_tsxPage);
Router.addRoute(route21);

const route22 = new Route("/mailing", mailing_page_tsxPage);
mailing_page_tsxSetPerm(route22);
Router.addRoute(route22);

const route23 = new Route("/mailing/pipeline/:id", mailing_pipeline__id__tsxPage);
mailing_pipeline__id__tsxSetPerm(route23);
Router.addRoute(route23);

const route24 = new Route("/mailing/pipelines-list", mailing_pipelines_list_index_tsxPage);
mailing_pipelines_list_index_tsxSetPerm(route24);
Router.addRoute(route24);

const route25 = new Route("/margem-convenio-service", margem_convenio_service_page_tsxPage);
margem_convenio_service_page_tsxSetPerm(route25);
Router.addRoute(route25);

const route26 = new Route("/mudancas-update", mudancas_update_page_tsxPage);
mudancas_update_page_tsxSetPerm(route26);
Router.addRoute(route26);

const route27 = new Route("/not-found", not_found_page_tsxPage);
Router.addRoute(route27);

const route28 = new Route("/", page_tsxPage);
page_tsxSetPerm(route28);
Router.addRoute(route28);

const route29 = new Route("/prospeccao-parceiros", prospeccao_parceiros_page_tsxPage);
prospeccao_parceiros_page_tsxSetPerm(route29);
Router.addRoute(route29);

const route30 = new Route("/servicos", servicos_page_tsxPage);
servicos_page_tsxSetPerm(route30);
Router.addRoute(route30);

const route31 = new Route("/sessoes-whatsapp", sessoes_whatsapp_page_tsxPage);
sessoes_whatsapp_page_tsxSetPerm(route31);
Router.addRoute(route31);

const route32 = new Route("/tabelas", tabelas_page_tsxPage);
tabelas_page_tsxSetPerm(route32);
Router.addRoute(route32);

const route33 = new Route("/usuario-bloqueado", usuario_bloqueado_index_tsxPage);
usuario_bloqueado_index_tsxSetPerm(route33);
Router.addRoute(route33);

const route34 = new Route("/usuarios", usuarios_page_tsxPage);
usuarios_page_tsxSetPerm(route34);
Router.addRoute(route34);

const route35 = new Route("/usuarios-bancos", usuarios_bancos_page_tsxPage);
usuarios_bancos_page_tsxSetPerm(route35);
Router.addRoute(route35);

const route36 = new Route("/vende-ai", vende_ai_page_tsxPage);
vende_ai_page_tsxSetPerm(route36);
Router.addRoute(route36);

const route37 = new Route("/whatsapp-service", whatsapp_service_page_tsxPage);
whatsapp_service_page_tsxSetPerm(route37);
Router.addRoute(route37);

